import { render, staticRenderFns } from "./baseInput.vue?vue&type=template&id=87ba0710&scoped=true"
import script from "./baseInput.vue?vue&type=script&lang=js"
export * from "./baseInput.vue?vue&type=script&lang=js"
import style0 from "./baseInput.vue?vue&type=style&index=0&id=87ba0710&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ba0710",
  null
  
)

export default component.exports